export class BusinessUnit {
    Name: string;
}
